import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ApiError, legacyAppUrl } from '@/lib/api'
import { Alert, Muted, PageHeader, Section } from '@/components/ui'
import { fetchWorkflowsHealth } from './api'

export function WorkflowsPage() {
  const health = useQuery({
    queryKey: ['workflows', 'health'],
    queryFn: fetchWorkflowsHealth,
    retry: false,
  })

  return (
    <section className="hi-page">
      <PageHeader
        title="Aprovações / Workflows"
        subtitle="API ainda expõe apenas health-check. Motor completo de aprovações no legado."
        actions={
          <>
            <a className="btn btn-primary" href={legacyAppUrl('#/workflows')}>
              Abrir no legado
            </a>
            <Link className="btn btn-secondary" to="/app">
              Voltar
            </Link>
          </>
        }
      />
      <Section title="Health">
        {health.isLoading ? <Muted>Verificando…</Muted> : null}
        {health.isError ? (
          <Alert tone="warning">
            {health.error instanceof ApiError
              ? health.error.message
              : 'Endpoint /workflows/health/ indisponível.'}
          </Alert>
        ) : null}
        {health.data ? (
          <pre className="hi-muted" style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
            {JSON.stringify(health.data, null, 2)}
          </pre>
        ) : null}
      </Section>
    </section>
  )
}
